import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withCtx as _withCtx, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2cbc7d5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modalscrollable" }
const _hoisted_2 = { class: "m-b-15" }
const _hoisted_3 = {
  for: "Nome",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_4 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_5 = { class: "m-b-15" }
const _hoisted_6 = {
  for: "Cognome",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_7 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_8 = { class: "m-b-15" }
const _hoisted_9 = {
  for: "codefiscale",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_10 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_11 = { class: "sm:col-span-2" }
const _hoisted_12 = {
  for: "citta",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
  style: {"display":"inline-block"}
}
const _hoisted_13 = {
  role: "status",
  style: {"display":"inline-block","margin-left":"2%"}
}
const _hoisted_14 = ["aria-hidden"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
  fill: "currentColor"
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
  fill: "currentFill"
}, null, -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_19 = { class: "m-b-15" }
const _hoisted_20 = { class: "relative" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"position":"absolute"},
  class: "inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    "aria-hidden": "true",
    class: "w-5 h-5 text-gray-500 dark:text-gray-400",
    fill: "currentColor",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    id: "search"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M448.3 424.7L335 311.3c20.8-26 33.3-59.1 33.3-95.1 0-84.1-68.1-152.2-152-152.2-84 0-152 68.2-152 152.2s68.1 152.2 152 152.2c36.2 0 69.4-12.7 95.5-33.8L425 448l23.3-23.3zM120.1 312.6c-25.7-25.7-39.8-59.9-39.8-96.3s14.2-70.6 39.8-96.3 59.9-40 96.2-40c36.3 0 70.5 14.2 96.2 39.9s39.8 59.9 39.8 96.3-14.2 70.6-39.8 96.3c-25.7 25.7-59.9 39.9-96.2 39.9-36.3.1-70.5-14.1-96.2-39.8z" })
  ])
], -1))
const _hoisted_22 = ["placeholder"]
const _hoisted_23 = ["selected", "value"]
const _hoisted_24 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_25 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_26 = { class: "m-b-15" }
const _hoisted_27 = {
  for: "data_di_nascita",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_28 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_29 = { class: "flex items-center" }
const _hoisted_30 = { role: "status" }
const _hoisted_31 = ["aria-hidden"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
  fill: "currentColor"
}, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
  fill: "currentFill"
}, null, -1))
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_36 = {
  for: "statomatrimoniale",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_37 = { class: "m-b-15" }
const _hoisted_38 = ["aria-readonly"]
const _hoisted_39 = ["selected", "value"]
const _hoisted_40 = { class: "m-b-15" }
const _hoisted_41 = {
  for: "sesso",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  hidden: ""
}, null, -1))
const _hoisted_43 = { value: "female" }
const _hoisted_44 = { value: "male" }

import { onMounted, ref, computed, reactive } from 'vue'
import { initFlowbite } from 'flowbite'
import { Input } from 'flowbite-vue'
import { storeToRefs } from 'pinia'
import AlertModal from "@/components/AlertModalFeedback.vue";
import debounce from '@/utils/debounce'
import { getGeoLocation } from "@/../../EshJSLib/services/geoService";
import { patientStore } from '@/store/patient'
import { getStatiMatrimoniali } from "../../../../EshJSLib/services/EshLOV";
import ErrorModal from '@/views/Components/ErrorModal.vue';
import { Modal } from "flowbite-vue";
import pazienteModalHeader from "@/views/schedaPaziente/pazienteModalHeader.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'pazienteBaseEdit',
  emits: ['cancel'],
  setup(__props, { emit }) {

const store = patientStore();
const { patient } = storeToRefs(store);
let extension = ref('');
let cittaSearch = ref(false);
let isOpenNas = ref(false);
let isOpen = ref(false);
let currentCityQueryNas = ref('');
let cityList = ref([]);
let pazienteModalTitle = ref("Aggiorna Informazioni anagrafiche");
let mandatoryFields = ['paziente_nome', 'paziente_cognome', 'paziente_codfiscale', ['user', 'contact_detail', 'comune_nascita'], 'paziente_nascita', 'paziente_sesso'];

const statiOptionList = ref([]);
const statovisible = ref(false);



let errors = ref([]);
let errorMessage = "Questo campo è obbligatorio!";
let errorMessageCF = "Codice Fiscale non valido!";

const alertModal = ref<InstanceType<typeof AlertModal> | null>(null);
const showLoading = ref(false);

onMounted(() => {
  patient.value.status = "update";
  initFlowbite();
  getStatiMatrimoniali().then(value => {
    statiOptionList.value = value
    statovisible.value = true
  })
  let index: number = patient.value.paziente_nascita.indexOf('T');
  if (index >= 0) {
    extension.value = patient.value.paziente_nascita.substring(index, patient.value.paziente_nascita.length);
    patient.value.paziente_nascita = patient.value.paziente_nascita.substring(0, index);
  }
});

const formattedDate = computed(() => {
  const date = new Date(patient.value.paziente_nascita);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear().toString();
  return `${day}/${month}/${year}`;
});

function validateFields() {
  errors.value = [];
  for (let field of mandatoryFields) {
    if(field == 'paziente_codfiscale') {
      errors.value.push(patient.value[field].length < 16 ? errorMessageCF : '');
    } else {
      let value = typeof field == 'string'? patient.value[field] : patient.value.user.contact_detail.comune_nascita;
      errors.value.push(!value ? errorMessage : '');
    }
  }
  errors.value.push(currentCityQueryNas.value != patient.value.user.contact_detail.comune_nascita && currentCityQueryNas.value != "" ?
  'Seleziona una delle città' : '');
  console.log(errors);
  return errors.value.filter(err => err != '').length == 0;
}


async function updateValue() {
  if(!validateFields()) { return false; }
  patient.value.paziente_nascita = patient.value.paziente_nascita + extension.value;

  patient.value.status = "update";
  localStorage.setItem('patient', JSON.stringify(patient.value));
  const userInput = await alertModal.value?.openModal("Salvare le modifiche ?", true);
  if (userInput) {
    showLoading.value = true;
    store.saveSchedaPaziente()
      .then(() => {
        showLoading.value = false;
        alertModal.value?.openModal("Salvato con successo! ", false)
        .then(() => cancelmodal());
        store.refreshScheda(store.patient.id_paziente)
      })
      .catch((res) => {
        showLoading.value = false;
        alertModal.value?.openModal("Siamo spiacenti si è verificato un errore. La preghiamo di riprovare più tardi", false);
        store.refreshScheda(store.patient.id_paziente)
      });
  }
}

function cancelmodal() {
  store.refreshScheda(patient.value.id_paziente);
  emit('cancel');
}


const isShowModal = reactive({
  dateError: false,
  alert: false,
});
function validateDate() {
  if (
    new Date(patient.value.paziente_nascita) >
    new Date()
  ) {
    errors.value[4] = 'La data inserita non è valida!';
    patient.value.paziente_nascita = new Date().toISOString().split('T')[0];
    return;

  }
  errors.value[4] = '';
}

const closeErrorModal = () => {
  isShowModal.dateError = false;
};

function switchVisNas(e) {
  isOpenNas.value = false;
  if (e.target == null) {
    return;
  }
  currentCityQueryNas.value = e.target.value;
}

const checkCurrentTownNas = debounce(async () => {
  cittaSearch.value = true;
  isOpen.value = false;
  const response = await getGeoLocation(currentCityQueryNas.value);
  cityList.value = response;
  isOpenNas.value = true;
  cittaSearch.value = false;
}, 700)


return (_ctx: any,_cache: any) => {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Modal), {
      onClose: _cache[11] || (_cache[11] = ($event: any) => (cancelmodal()))
    }, {
      header: _withCtx(() => [
        _createVNode(pazienteModalHeader, {
          title: _ctx.$t(_unref(pazienteModalTitle))
        }, null, 8, ["title"])
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('Nome')), 1),
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass([{ 'border-red-500': _unref(errors)[0] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"]),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(patient).paziente_nome) = $event)),
              type: "text",
              id: "nome",
              required: ""
            }, null, 2), [
              [_vModelText, _unref(patient).paziente_nome]
            ]),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(errors)[0]), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('Cognome')), 1),
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass([{ 'border-red-500': _unref(errors)[1] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"]),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(patient).paziente_cognome) = $event)),
              type: "text",
              id: "cognome",
              required: ""
            }, null, 2), [
              [_vModelText, _unref(patient).paziente_cognome]
            ]),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(errors)[1]), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('Codice Fiscale')), 1),
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass([{ 'border-red-500': _unref(errors)[2] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"]),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(patient).paziente_codfiscale) = $event)),
              type: "text",
              id: "codefiscale",
              required: ""
            }, null, 2), [
              [_vModelText, _unref(patient).paziente_codfiscale]
            ]),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(errors)[2]), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("Città di nascita ")), 1),
            _withDirectives(_createElementVNode("div", _hoisted_13, [
              (_openBlock(), _createElementBlock("svg", {
                "aria-hidden": !_unref(cittaSearch),
                class: "w-5 h-5 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600",
                viewBox: "0 0 100 101",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, _hoisted_17, 8, _hoisted_14)),
              _hoisted_18
            ], 512), [
              [_vShow, _unref(cittaSearch)]
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "citta",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(currentCityQueryNas) ? (currentCityQueryNas).value = $event : currentCityQueryNas = $event)),
                  onKeyup: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(checkCurrentTownNas) && _unref(checkCurrentTownNas)(...args))),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => {_isRef(isOpenNas) //@ts-ignore
 ? isOpenNas.value = true : isOpenNas = true; _isRef(isOpen) //@ts-ignore
 ? isOpen.value = false : isOpen = false}),
                  class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                  placeholder: _unref(patient).user.contact_detail.comune_nascita
                }, null, 40, _hoisted_22), [
                  [_vModelText, _unref(currentCityQueryNas)]
                ])
              ]),
              _withDirectives(_createElementVNode("select", {
                id: "cittaSearch",
                onChange: _cache[6] || (_cache[6] = ($event: any) => (switchVisNas($event))),
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(patient).user.contact_detail.comune_nascita) = $event)),
                size: "10",
                class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cityList), (item) => {
                  return (_openBlock(), _createElementBlock("option", {
                    class: _normalizeClass({ 'border-red-500': _unref(errors)[3] }),
                    selected: item.city,
                    key: item.city,
                    value: item.city
                  }, _toDisplayString(item.city), 11, _hoisted_23))
                }), 128))
              ], 544), [
                [_vShow, _unref(isOpenNas) === true],
                [_vModelSelect, _unref(patient).user.contact_detail.comune_nascita]
              ]),
              _createElementVNode("p", _hoisted_24, _toDisplayString(_unref(errors)[3]), 1),
              _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(errors)[3] == "" ? _unref(errors)[6] : ''), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('Data di nascita')), 1),
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass([{ 'border-red-500': _unref(errors)[4] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"]),
              onChange: validateDate,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(patient).paziente_nascita) = $event)),
              type: "date",
              id: "data"
            }, null, 34), [
              [_vModelText, _unref(patient).paziente_nascita]
            ]),
            _createElementVNode("p", _hoisted_28, _toDisplayString(_unref(errors)[4]), 1)
          ]),
          _createElementVNode("li", _hoisted_29, [
            _withDirectives(_createElementVNode("div", _hoisted_30, [
              (_openBlock(), _createElementBlock("svg", {
                "aria-hidden": statovisible.value,
                class: "w-5 h-5 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600",
                viewBox: "0 0 100 101",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, _hoisted_34, 8, _hoisted_31)),
              _hoisted_35
            ], 512), [
              [_vShow, !statovisible.value]
            ]),
            _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t('Stato Civile')), 1)
          ]),
          _createElementVNode("div", _hoisted_37, [
            _withDirectives(_createElementVNode("select", {
              id: "statoMatr",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(patient).id_stato_matrimoniale) = $event)),
              "aria-readonly": statovisible.value,
              name: "statomatrimoniale",
              class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statiOptionList.value, (stato) => {
                return (_openBlock(), _createElementBlock("option", {
                  selected: _unref(patient).id_stato_matrimoniale != null && stato.id_stato_matrimoniale === _unref(patient).id_stato_matrimoniale,
                  key: stato.id_stato_matrimoniale,
                  value: stato.id_stato_matrimoniale
                }, _toDisplayString(stato.stato_matrimoniale_nome), 9, _hoisted_39))
              }), 128))
            ], 8, _hoisted_38), [
              [_vModelSelect, _unref(patient).id_stato_matrimoniale]
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t('Sesso')), 1),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(patient).paziente_sesso) = $event)),
              id: "sesso",
              class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            }, [
              _hoisted_42,
              _createElementVNode("option", _hoisted_43, _toDisplayString(_ctx.$t('female')), 1),
              _createElementVNode("option", _hoisted_44, _toDisplayString(_ctx.$t('male')), 1)
            ], 512), [
              [_vModelSelect, _unref(patient).paziente_sesso]
            ])
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          id: "submitAnagrafica",
          onClick: updateValue,
          class: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
        }, _toDisplayString(_ctx.$t('Salva')), 1)
      ]),
      _: 1
    }),
    _createVNode(AlertModal, {
      ref_key: "alertModal",
      ref: alertModal
    }, null, 512),
    (showLoading.value)
      ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(ErrorModal, {
      isShown: isShowModal.dateError === true,
      errorMessage: _ctx.$t('validDate'),
      onClose: closeErrorModal
    }, null, 8, ["isShown", "errorMessage"])
  ], 64))
}
}

})